import React from "react"
import PropTypes from "prop-types"
import { Container, Title } from "@bw/bits"
import styled, { css } from "styled-components"
import { breakpoints } from "../../../theme"

const StyledSection = styled.section`
  --offset: 60px;
  margin: var(--offset) 0;

  ${props =>
    props.backgroundVariant &&
    css`
      margin-top: 0;
      padding: var(--offset) 0 0;
      position: relative;

      &:before {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 80%;
        max-height: 480px;
        background-color: rgba(26, 62, 94, 0.05);
        clip-path: polygon(0 0, 100% 0, 100% c;lc(100% - 20px), 0 100%);

        @media (min-width: ${breakpoints.medium}px) {
          clip-path: polygon(0 0, 100% 0, 100% calc(100% - 105px), 0 100%);
        }
      }
    `}

  .title {
    margin-bottom: 25px;

    @media (min-width: ${breakpoints.medium}px) {
      margin-bottom: 40px;
    }
  }
`
const ButtonWrapper = styled.div`
  position: relative;
  z-index: 1;
  transform: translateY(50%);
  display: flex;
  flex-direction: row;
  justify-content: ${props =>
    props.$justify === "center" ? "center" : `flex-${props.$justify}`};
`

const Grid = styled.div`
  @media (min-width: ${breakpoints.medium}px) {
    display: grid;
    grid-template-columns: 2fr 3fr;
  }

  @media (min-width: ${breakpoints.medium}px) {
    grid-template-columns: 1fr 2fr;
  }
`

const Section = ({
  suptitle,
  title,
  subtitle,
  fullWidth,
  containerSize,
  children,
  button,
  buttonPosition,
  titleOnSide,
  margin,
  backgroundVariant,
}) => {
  if (titleOnSide) {
    return (
      <StyledSection
        backgroundVariant={backgroundVariant}
        $margin={margin}
        className="section section--title-on-side"
      >
        <Container size={containerSize}>
          <Grid>
            {(suptitle || title) && (
              <Title {...{ suptitle, title, subtitle }} />
            )}
            <div>
              {children}

              {button && (
                <Container size={containerSize}>
                  <ButtonWrapper $justify={buttonPosition}>
                    {button}
                  </ButtonWrapper>
                </Container>
              )}
            </div>
          </Grid>
        </Container>
      </StyledSection>
    )
  }

  const content = fullWidth ? (
    children
  ) : (
    <Container size={containerSize}>{children}</Container>
  )

  return (
    <StyledSection backgroundVariant={backgroundVariant} className="section">
      {(suptitle || title) && (
        <Container size={containerSize}>
          <Title {...{ suptitle, title, subtitle }} />
        </Container>
      )}
      {content}
      {button && (
        <Container size={containerSize}>
          <ButtonWrapper $justify={buttonPosition}>{button}</ButtonWrapper>
        </Container>
      )}
    </StyledSection>
  )
}

Section.propTypes = {
  suptitle: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  fullWidth: PropTypes.bool,
  titleOnSide: PropTypes.bool,
  backgroundVariant: PropTypes.bool,
  button: PropTypes.element,
  buttonPosition: PropTypes.oneOf(["start", "center", "end"]),
  containerSize: PropTypes.oneOf(["small", "medium", "large"]),
}

Section.defaultProps = {
  buttonPosition: "center",
  containerSize: "medium",
}

export { Section }
